import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from '../../../shared/components';

export default function HeaderTitlePatientList({
  totalPacientes,
}) {
  return (
    <Box>
      <Text
        fontWeight="bold"
        fontSize={16}
        translationId="generico.resultados"
        upperCase={undefined}
        lowerCase={undefined}
        children={undefined}
      />
      <Text
        fontWeight="bold"
        fontSize={16}
        translationId={undefined}
        upperCase={undefined}
        lowerCase={undefined}
      >
        &nbsp;
        {`(${totalPacientes})`}
      </Text>
    </Box>
  );
}

HeaderTitlePatientList.propTypes = {
  totalPacientes: PropTypes.number,
};

HeaderTitlePatientList.defaultProps = {
  totalPacientes: 0,
};
